// Swap in Sharon's real scheduling link here, or set REACT_APP_CALENDLY_URL.
export const CALENDLY_URL =
  process.env.REACT_APP_CALENDLY_URL ||
  "https://calendly.com/genesisconsultinghq/30min";

export const CALENDLY_BRAND = {
  background_color: "FAF8F5",
  text_color: "1A1A1A",
  primary_color: "C5A880",
};
